export const PAGE_VIEW = 'virtualPageView'
export const FORM_1_SUBMIT = 'form1.submit'
export const FORM_2_SUBMIT = 'form2.submit'

// Page types
export const FORM_PAGE = 'form_page'
